import RelendTokenV2Logo from "@/assets/icons/relend-token-v2.png"
import { SupplyToEarnApy, SupplyToEarnReward } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"

export const USDS_STE: SupplyToEarnApy = {
  account: {
    apy: 100,
    rewardToken: "REL",
    reserve: "HUL7GeHECRMbBFwde6pBmCPwDZjoLQDX7Xis4d64jAya",
    chainId: 101,
    address: "9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV",
    name: "Relend Token",
    symbol: "REL",
    tokenDecimals: 9,
    logoURI: RelendTokenV2Logo.src,
    tags: [],
    extensions: {},
    startTime: 1732665600, // 2024-11-27 0:00:00 UTC
    endTime: 1733961600, // 2024-12-12 0:00:00 UTC
    totalAccumulatedRewards: "",
    totalRewards: (1_000_000 * 10 ** 9).toString(),
  },
  publicKey: "HUL7GeHECRMbBFwde6pBmCPwDZjoLQDX7Xis4d64jAya",
}

export const USDS_STE_REWARD: SupplyToEarnReward = {
  totalRewardNumber: "",
  accumulatedRewardAmount: "",
  lastSupply: "",
  apy: 100,
  supplyAmount: "",
  chainId: 101,
  address: "9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV",
  name: "Relend Token",
  symbol: "REL",
  rewardDecimals: 9,
  reserveDecimals: 6,
  logoURI: RelendTokenV2Logo.src,
  tags: [],
  extensions: {},
  currentTime: "",
  reserve: "HUL7GeHECRMbBFwde6pBmCPwDZjoLQDX7Xis4d64jAya",
  startTime: 1732665600, // 2024-11-27 0:00:00 UTC
  endTime: 1733961600, // 2024-12-12 0:00:00 UTC
  totalAccumulatedRewards: "",
  totalRewards: (1_000_000 * 10 ** 9).toString(),
}

export const supplyToEarnAPYAtom = atom<SupplyToEarnApy[]>([])

export const supplyToEarnRewardAtom = atom<SupplyToEarnReward[]>([])

export const supplyToEarnVaultRewardBalancesAtom = atom<Record<string, any>>({})
